// @flow

import React from "react";
import { localize } from "redux-i18n";

import { formatDate } from "@transformers/date";
import { ColumnsContainer, Row, Col } from "@components";
import type { Rows } from "@components/columns-container/types";
import type { Alert } from "@modules/service/reducer/alerts/types";

type Props = $Exact<{
  data: Alert,
  ...PropsFromLocalize,
}>;

export class AlertCriteriaView extends React.Component<Props> {
  get data(): Array<Rows> {
    return [
      {
        columns: [
          {
            data: [
              [this.props.t("ALERTS_ALERT_ID"), this.props.data.id],
              [
                this.props.t("ALERTS_ALERT_TYPE"),
                this.props.t(this.props.data.content.details.alertType),
              ],
              [
                this.props.t("ALERTS_ALERT_TRIGGER_POINT"),
                this.props.t(this.props.data.content.details.triggerMode),
              ],
            ],
          },
          {
            data: [
              [this.props.t("ALERTS_ALERT_NAME"), this.props.data.content.details.name],
              [
                this.props.t("ALERTS_ALERT_ABSENCE_TYPE"),
                this.props.t(this.props.data.content.details.absenceType),
              ],
              [
                this.props.t("ALERTS_ALERT_VALID_FROM"),
                formatDate(this.props.data.content.details.activeFrom),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("STATUS"),
                this.props.data.content.details.isActive
                  ? this.props.t("ACTIVE")
                  : this.props.t("INACTIVE"),
              ],
              [
                this.props.t("ALERTS_ALERT_PURPOSE"),
                this.props.t(this.props.data.content.details.alertPurpose),
              ],
              [
                this.props.t("ALERTS_ALERT_END_DATE"),
                formatDate(this.props.data.content.details.activeTo),
              ],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer rows={this.data} />;
  }
}

export default localize()(AlertCriteriaView);
